import { render, staticRenderFns } from "./fixed-view.vue?vue&type=template&id=13a3f84e&scoped=true&"
import script from "./fixed-view.vue?vue&type=script&lang=js&"
export * from "./fixed-view.vue?vue&type=script&lang=js&"
import style0 from "./fixed-view.vue?vue&type=style&index=0&id=13a3f84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3f84e",
  null
  
)

export default component.exports